document.addEventListener('DOMContentLoaded', function () {
  const institutionalVideos = document.querySelector('.institutional-videos');
  if (!institutionalVideos) return;

  var swiper = new Swiper('.institutional-videos .swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    allowTouchMove: true,
    simulateTouch: true,
    grabCursor: true,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      769: {
        spaceBetween: 24,
      }
    }
  });

  window.playVideo = function (posterOverlay) {
    const videoElement = posterOverlay.nextElementSibling;

    let videoSrc = null;

    if (videoElement && videoElement.getAttribute('src')) {
      videoSrc = videoElement.getAttribute('src');
    }
    else if (videoElement) {
      const sourceElement = videoElement.querySelector('source');
      if (sourceElement) {
        videoSrc = sourceElement.getAttribute('src');
      }
    }

    if (!videoSrc && videoElement) {
      videoSrc =
        videoElement.getAttribute('data-src') ||
        videoElement.getAttribute('data-video-src') ||
        videoElement.currentSrc;
    }

    if (!videoSrc && videoElement) {
      const htmlMatch = videoElement.outerHTML.match(/src="([^"]+)"/);
      if (htmlMatch) {
        videoSrc = htmlMatch[1];
      }
    }

    const modal = document.getElementById('video-modal');
    const modalVideo = document.getElementById('modal-video');

    modalVideo.src = videoSrc;
    modal.style.display = 'flex';
    modalVideo.play().catch((e) => console.error('Video play error:', e));

    document.documentElement.classList.add('no-scroll');
  };

  window.closeModal = function () {
    const modal = document.getElementById('video-modal');
    const modalVideo = document.getElementById('modal-video');

    modalVideo.pause();
    modal.style.display = 'none';
    modalVideo.src = '';

    document.documentElement.classList.remove('no-scroll');
  };
});
